import { Download, CheckCircle2 } from "lucide-react";
import { proxied } from "@/lib/api";

const SiddhaMalaFeature = ({ settings = {} }) => {
  const bullets = settings.siddha_bullets || [];
  const brochureUrl = settings.siddha_brochure_url;

  const handleDownload = (e) => {
    if (!brochureUrl) {
      e.preventDefault();
      alert("Brochure will be available soon. Please contact us on WhatsApp.");
    }
  };

  return (
    <section id="siddha-mala" className="bg-[#FAF6F0] pt-12 pb-16 md:py-24">
      {/* Golden Section Header (both mobile + desktop) */}
      <div className="max-w-4xl mx-auto px-6 text-center mb-10 md:mb-14">
        <h2
          className="font-serif italic tracking-tight text-4xl md:text-6xl"
          style={{
            background: "linear-gradient(135deg, #D4AF37 0%, #b5952f 45%, #C89838 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          25th Anniversary Navratri Offers
        </h2>
        <p className="mt-3 text-[11px] md:text-sm tracking-[0.4em] md:tracking-[0.5em] uppercase text-[#8B2323] font-medium">
          {settings.siddha_kicker || ""}
        </p>
        <div className="h-[2px] w-12 md:w-16 bg-[#D4AF37] mt-4 md:mt-5 mx-auto" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
        {/* Image (order-1 on mobile so it appears right after golden title) */}
        <div className="order-1 md:order-2 relative">
          <div className="absolute -inset-4 md:-inset-8 rounded-[2rem] bg-gradient-to-br from-[#8B2323]/12 via-transparent to-[#D4AF37]/12 blur-2xl" />
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden bg-[#F5EEDD] border border-[#D4AF37]/25">
            <img
              src={proxied(settings.siddha_image)}
              alt="Sacred Siddha Mala"
              className="w-full h-full object-cover"
            />
            <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#8B2323] text-white text-[9px] tracking-[0.35em] uppercase">
              Lab Certified
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="order-2 md:order-1">
          <p className="mt-4 md:mt-2 text-[#2D2825] text-sm md:text-lg leading-relaxed whitespace-pre-line">
            {settings.siddha_intro}
          </p>

          {bullets.length > 0 && (
            <ul className="mt-5 space-y-2.5">
              {bullets.map((b, i) => (
                <li key={i} className="flex gap-3 items-start text-sm md:text-base text-[#2D2825] leading-snug">
                  <CheckCircle2 size={16} className="text-[#8B2323] flex-shrink-0 mt-1" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          )}

          {settings.siddha_footer && (
            <p className="mt-5 text-xs md:text-base text-[#5C544F] italic leading-relaxed whitespace-pre-line">
              {settings.siddha_footer}
            </p>
          )}

          <a
            href={brochureUrl || "#"}
            onClick={handleDownload}
            download={brochureUrl ? "Rudralife-Siddha-Mala-Brochure.pdf" : undefined}
            target={brochureUrl ? "_blank" : undefined}
            rel="noreferrer"
            data-cursor="button"
            data-testid="siddha-brochure-download"
            className="mt-6 md:mt-8 inline-flex items-center gap-3 px-6 md:px-7 py-3.5 md:py-4 rounded-full bg-[#8B2323] hover:bg-[#6B1A1A] text-white text-[10px] md:text-xs tracking-[0.3em] uppercase font-medium transition-all hover:shadow-[0_15px_35px_rgba(139,35,35,0.35)]"
          >
            <Download size={16} />
            {settings.siddha_brochure_cta || "Download Siddha Mala Brochure"}
          </a>
        </div>
      </div>
    </section>
  );
};

export default SiddhaMalaFeature;
